import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { usePresentacionContext } from "../context/presentacion.context";
import { NumericFormat } from "react-number-format";
import { GetDateLocal } from "../../shared/utilitties/formatDate";
import { Badge } from "primereact/badge";
import {
  consultarTransaccionesDetalles,
  transaccionesExcluir,
  transaccionesIncluir,
} from "../services/transacciones.service";
import { createTransaccionAdapter, transaccionesAdapter, transaccionesDetallesAdapter } from "../adapters/transaccion.adapter";
import {
  INICIADA_COMERCIO, RECHAZADA,
} from "../utilities/constants";
import {
  TRANSACCIONES_DISPONIBLES,
  TRANSACCIONES_SELECCIONADAS,
} from "../../shared/utilitties/constants";

import { MESSAGE_ERROR_EXCLUIR_TRANSACCIONES_DETALLES, MESSAGE_ERROR_TRANSACCIONES_DETALLES, MESSAGE_FAILED_TRANSACCIONES_DETALLES, MESSAGE_NO_HAY_TRANSACIONES_SELECCIONADAS, MESSAGE_TRX_FECHA_MAYOR_90_DS, MESSAGE_TRX_PRECIO_LITRO_BAJO, MESSAGE_LOTE_PRECIO_LITRO_BAJO } from "../utilities/messages.utilities";

import "./TransaccionesDataTable.css";
import { Lote } from "../models/Lote.model";
import { Transaccion } from "../models/Transaccion.model";
import moment from "moment";
import { Tooltip } from "primereact/tooltip";
import { InputText } from "primereact/inputtext";

interface DataTableExpandedRows {
  [key: string]: boolean;
}
interface Props{
  setMask:Function
}

const TransaccionesDetalles = (props:Props) => {
  const {
    presentacion,
    detailsTxDisponibles,
    detailsTxSeleccionadas,
    setDetailsTxDisponibles,
    setDetailsTxSeleccionadas,
    selectedTxSeleccionadas,
    setSelectedTxSeleccionadas,
    setSpinnerImpuestosTasas,
    setLoadFacturaComercio,
    flagUpdateTxDisponibles,setFlagUpdateTxDisponibles,
    presentacionEditable,presentacionComercio,
    lotesPendientes
  } = usePresentacionContext();

  const [expandedRowsDisponibles, setExpandedRowsDisponibles] = useState<
    any[] | DataTableExpandedRows
  >([]);
  const [selectedLotesDisponibles, setselectedLotesDisponibles] = useState<any[]>([]);
  const [checkedAllDisponibles, setCheckedAllDisponibles] = useState(false);
  const [selectedTxsDisponibles, setSelectedTxsDisponibles] = useState<any[]>([]);
  const [selectedTxsSeleccionadas, setSelectedTxsSeleccionadas] = useState<any[]>([]);
  const [selectedLotesSeleccionados, setSelectedLotesSeleccionados] = useState<any[]>([]);

  const [expandedRowsSeleccionadas, setExpandedRowsSeleccionadas] = useState<
    any[] | DataTableExpandedRows
  >([]);
  const [checkedAllSeleccionadas, setCheckedAllSeleccionadas] = useState(false);
  const [spinnerTxDisponibles, setSpinnerTxDisponibles] = useState(false);
  const [spinnerTxSeleccionadas, setSpinnerTxSeleccionadas] = useState(false);

  const toast = useRef<Toast>(null);
  const isMounted = useRef(false);
  const dt = useRef(null);
  useEffect(() => {
    if (isMounted.current) {
      const summary =
        expandedRowsDisponibles !== null
          ? "All Rows Expanded"
          : "All Rows Collapsed";
      // toast.current.show({severity: 'success', summary: `${summary}`, life: 3000});
    }
  }, []);

  /*const onRowExpand = (event: any) => {
    // toast.current.show({severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000});
  };

  const onRowCollapse = (event: any) => {
    //toast.current.show({severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000});
  };*/

  const expandAll = (id: number) => {
    let _expandedRows: any = {};
    if (id == 1) {
      detailsTxDisponibles.forEach(
        (p: any) => (_expandedRows[`${p.nro}`] = true)
      );
      setExpandedRowsDisponibles(_expandedRows);
    } else {
      detailsTxSeleccionadas.forEach(
        (p: any) => (_expandedRows[`${p.nro}`] = true)
      );
      setExpandedRowsSeleccionadas(_expandedRows);
    }
  };

  const collapseAll = (id: number) => {
    id === TRANSACCIONES_DISPONIBLES
      ? setExpandedRowsDisponibles([])
      : setExpandedRowsSeleccionadas([]);
  };

  const allowExpansion = (rowData: any) => {
    return rowData.detalles.length > 0;
  };

  const exportExcel = (id: number) => {
    import("xlsx").then((xlsx) => {
      if (id === TRANSACCIONES_DISPONIBLES) {
        let transacciones:any= []
        detailsTxDisponibles.forEach((item:any) =>{
          let it = transaccionesAdapter(item)
          transacciones.push(it)
        })
        const worksheet = xlsx.utils.json_to_sheet(transacciones);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer, "TransaccionesDisponibles");
        let txd: any[] = [];
        detailsTxDisponibles.forEach((item: any) => {
          let txDetail = item.detalles;
          txDetail.forEach((it: any) => {
            let detail= transaccionesDetallesAdapter(it)
            txd.push(detail);
          });
        });

        const worksheet2 = xlsx.utils.json_to_sheet(txd);
        const workbook2 = {
          Sheets: { data: worksheet2 },
          SheetNames: ["data"],
        };
        const excelBuffer2 = xlsx.write(workbook2, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer2, "DetalleTransaccionesDisponibles");
      } else {
        let transacciones:any= []
        detailsTxSeleccionadas.forEach((item:any) =>{
          let it = transaccionesAdapter(item)
          transacciones.push(it)
        })
        const worksheet = xlsx.utils.json_to_sheet(transacciones);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer, "TransaccionesSeleccionadas");

        let txd: any[] = [];
        detailsTxSeleccionadas.forEach((item: any) => {
          let txDetail = item.detalles;
          txDetail.forEach((it: any) => {
            let detail= transaccionesDetallesAdapter(it)
            txd.push(detail);
          });
        });
        const worksheet2 = xlsx.utils.json_to_sheet(txd);
        const workbook2 = {
          Sheets: { data: worksheet2 },
          SheetNames: ["data"],
        };
        const excelBuffer2 = xlsx.write(workbook2, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer2, "DetalleTransaccionesSeleccionadas");
      }
    });
  };
  const saveAsExcelFile = (buffer: BlobPart, fileName: string) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };


  const onIncluirTxDisponibles = async () => {
    if(selectedTxsDisponibles.length === 0){
      toast.current?.show({severity: 'warn', summary: 'Message', detail: MESSAGE_NO_HAY_TRANSACIONES_SELECCIONADAS, life: 5000});
      return;
    } 
    props.setMask(true)
    let precupon = "";
    
    setSpinnerImpuestosTasas(true)
    setSpinnerTxSeleccionadas(true);
    setLoadFacturaComercio(true)
    if (window.location.href.indexOf("presentacion=") > 0) {
      precupon = window.location.href.split("=")[1];
    } else {
      precupon = presentacion;
    }

    setSpinnerTxDisponibles(true);

    let txDetalles = selectedTxsDisponibles.map((tx: Transaccion) => {
      return {
        CierreLote: "",
        IdTransaccion: tx.id_transaccion,
        IdProducto: 0
      }
    });

    const data = {
      IdAfiliado: 0,
      PreCupon: parseInt(precupon),
      TransaccionesIncluir: txDetalles
    };
    
    const resultIncluirTx = await transaccionesIncluir(data);
    if (resultIncluirTx.status === 200) {
      if(resultIncluirTx.data == 0){
        let resultDetailsTransacction = await consultarTransaccionesDetalles(parseInt(precupon));
        if (resultDetailsTransacction.status === 200) {
          setDetailsTxDisponibles(
            resultDetailsTransacction.data.transaccionesDisponibles
          );
          setDetailsTxSeleccionadas(
            resultDetailsTransacction.data.transaccionesSeleccionadas
          );
        }
      }else{
        if(resultIncluirTx.data == 9){
          toast.current?.show({severity: 'warn', summary: 'Message', detail: MESSAGE_FAILED_TRANSACCIONES_DETALLES, life: 5000});
          setSpinnerTxDisponibles(false);
          setSpinnerTxSeleccionadas(false);
        }
        props.setMask(false)
      }
    }else{
      setLoadFacturaComercio(false)
      toast.current?.show({severity: 'error', summary: 'Message', detail: MESSAGE_ERROR_TRANSACCIONES_DETALLES, life: 5000})
      props.setMask(false)
    }
    setFlagUpdateTxDisponibles(flagUpdateTxDisponibles + 1)
    setSpinnerTxDisponibles(false);
    setSpinnerTxSeleccionadas(false);
    setselectedLotesDisponibles([]);
    setSelectedTxsDisponibles([]);
  };

  const onExcluirTxSeleccionadas = async () => {
    if (selectedTxsSeleccionadas.length === 0) {
      toast.current?.show({severity: 'warn', summary: 'Message', detail: MESSAGE_NO_HAY_TRANSACIONES_SELECCIONADAS, life: 5000});
      return;
    }

    props.setMask(true)
    let precupon = "";
    
    
    setSpinnerImpuestosTasas(true)
    setSpinnerTxDisponibles(true)
    setLoadFacturaComercio(true)
    if (window.location.href.indexOf("presentacion=") > 0) {
      precupon = window.location.href.split("=")[1];
    } else {
      precupon = presentacion;
    }

    setSpinnerTxSeleccionadas(true);

    let txDetalles = selectedTxsSeleccionadas.map((tx: Transaccion) => {
      return {
        CierreLote: "",
        IdTransaccion: tx.id_transaccion,
        IdProducto: 0
      }
    });

    const data = {
      IdAfiliado: 0,
      PreCupon: parseInt(precupon),
      TransaccionesExcluir: txDetalles,
    };
    const resultExcluirTx = await transaccionesExcluir(data);
    if (resultExcluirTx.status === 200) {
      let resultDetailsTransacction = await consultarTransaccionesDetalles(
        parseInt(precupon)
      );
      if (
        resultDetailsTransacction.status === 200
      ) {
        setDetailsTxDisponibles(
          resultDetailsTransacction.data.transaccionesDisponibles
        );
        setDetailsTxSeleccionadas(
          resultDetailsTransacction.data.transaccionesSeleccionadas
        );
        setFlagUpdateTxDisponibles(flagUpdateTxDisponibles + 1)
      }
    }else{
      setLoadFacturaComercio(false)
      toast.current?.show({severity: 'error', summary: 'Message', detail: MESSAGE_ERROR_EXCLUIR_TRANSACCIONES_DETALLES, life: 5000})
      props.setMask(false)
      setFlagUpdateTxDisponibles(flagUpdateTxDisponibles + 1)
    }        
    setCheckedAllSeleccionadas(false);
    setSpinnerTxDisponibles(false);
    setSpinnerTxSeleccionadas(false);
    setSelectedLotesSeleccionados([]);
    setSelectedTxsSeleccionadas([]);
  };

  const renderHeader = (title: string, typeTx: number) => {
    return (
      <div className="p-grid p-justify-between p-align-center">
        <div className="p-col-12 p-md-4" style={{ textAlign: "left" }}>
          <p className="t4">{title}</p>
        </div>
        <div className="p-col-12 p-md-8" style={{ textAlign: "end" }}>
          <div className="table-header-container">
            <div className="button-demo">
              <div className="template">
                <Button
                  className="eden-clr-blue p-0"
                  aria-label="Expandir"
                  onClick={() => expandAll(typeTx)}
                >
                  <i className="pi pi-plus px-2"></i>
                  <span className="px-3">Expandir Todo</span>
                </Button>
                <Button
                  className="eden-clr-blue p-0"
                  aria-label="Contraer"
                  onClick={() => collapseAll(typeTx)}
                >
                  <i className="pi pi-minus px-2"></i>
                  <span className="px-3">Contraer Todo</span>
                </Button>

                <Button
                  className="eden-clr-bluegray p-0"
                  aria-label="Exportar"
                  onClick={() => exportExcel(typeTx)}
                >
                  <i className="pi pi-download px-2"></i>
                  <span className="px-3">Exportar</span>
                </Button>
                {presentacionComercio.descripcion === INICIADA_COMERCIO || presentacionComercio.descripcion === RECHAZADA
                ? ((typeTx === TRANSACCIONES_DISPONIBLES ) 
                ? (<Button
                  className="eden-clr-green p-0"
                  aria-label="Incluir"
                    onClick={() => onIncluirTxDisponibles()}
                    
                  >
                    <i className="pi pi-arrow-circle-down px-2"></i>
                    <span className="px-3">Incluir Seleccionadas</span>
                     {selectedTxsDisponibles.length > 0 && (
                      <Badge
                        className="mr-2"
                          value={String(selectedTxsDisponibles.length)}
                        severity="success"
                      />
                    )}
                  </Button>) 
                  : (<Button
                    className="eden-clr-red p-0"
                    aria-label="Excluir"
                    onClick={() => onExcluirTxSeleccionadas()}
                    
                  >
                    <i className="pi pi-arrow-circle-up px-2"></i>
                    <span className="px-3">Excluir Seleccionadas</span>
                      {selectedTxsSeleccionadas.length > 0 && (
                      <Badge
                        className="mr-2"
                          value={String(selectedTxsSeleccionadas.length)}
                        severity="success"
                      />
                    )}
                  </Button>
                ))
                :<></>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const dateBodyTemplate = (dateRow: any) => {
    return (
      <React.Fragment>
        {dateRow != null ? GetDateLocal(dateRow) : ""}
      </React.Fragment>
    );
    };
    const descServicioBodyTemplate = (dateRow: any) => {
    return <React.Fragment>{dateRow.desc_producto}</React.Fragment>;
    };

    //const descSolucionBodyTemplate = (dateRow: any) => {
    //    return <React.Fragment>{dateRow.desc_solucion}</React.Fragment>;
    //};

  const cantidadBodyTemplate = (dateRow: any) => {
    return (
      <React.Fragment>
        {dateRow.cantidad_Litros}
      </React.Fragment>
    );
  };
  const rowExpansionTemplate = (data: any, typeTx: number) => {
    return (
      <div className="orders-subtable">
        <DataTable
          value={data}
          responsiveLayout="stack"
          className="detTxDataTable"
          size="small"
          selection={typeTx === TRANSACCIONES_DISPONIBLES ? selectedTxsDisponibles : selectedTxsSeleccionadas}
          onSelectionChange={(e) => typeTx === TRANSACCIONES_DISPONIBLES ? onSelectedTxsDisponibles(e) : onSelectedTxsSeleccionadas(e)}
        >
          <Column field="cierreLote"
            header="Cierre de lote"
            body={(detalle) => precioLitroBajoCellTemplate(detalle)}
            style={{ width: "20%" }}                        
          />
          <Column
            field="numero_comprobante_terminal"
            header="Comprobante"
            style={{ width: "13%" }}
          ></Column>
          <Column
            field="fecha_transaccion"
            header="Fecha"
            body={(detalle) => dateBodyTemplate(detalle.fecha_transaccion)}
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="desc_producto"
            header="Producto"
            body={(detalle) => descServicioBodyTemplate(detalle)}
            style={{ width: "13%" }}
            />
          <Column
            field="cantidad"
            header="Cantidad"
            body={(detalle) => cantidadBodyTemplate(detalle)}
            style={{ textAlign: "right", width: "13%" }}
          ></Column>
          <Column
            header="Importe con descuento"
            body={totalBodyTemplate}
            style={{ textAlign: "right", width: "19%" }}
          ></Column>
          <Column
            header="Importe"
            body={totalSinDescuentoBodyTemplate}
            style={{ textAlign: "right", width: "10%" }}
          ></Column>
          {presentacionEditable &&
            <Column
              className="column-selection"
              selectionMode="multiple"
              headerStyle={{ width: "6%" }}
              headerClassName="no-header-checkbox"
            />
          }
        </DataTable>
      </div>
    );
  };
  const totalSinDescuentoBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <NumericFormat
          value={rowData.montoSinDescuento}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          prefix={"$"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      </React.Fragment>
    );
  };
  const totalBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        {/*<span className="p-column-title">Total</span>*/}
        <NumericFormat
          value={rowData.monto}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          prefix={"$"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      </React.Fragment>
    );
  };
  const ProductoBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        {/*<span className="p-column-title">Producto</span>*/}
        {rowData.detalles.length > 0 && rowData.detalles[0].desc_solucion}
      </React.Fragment>
    );
  };

  const onselectedLotesDisponibles = (e: any) => {
    setCheckedAllDisponibles(!checkedAllDisponibles);
    setselectedLotesDisponibles(e.value);
    handleSelectedTxsDisponibles(e);
  }; 
  const handleSelectedTxsDisponibles = (e: any) => {
    const detallesSeleccionados = Array.from(new Set(selectedTxsDisponibles.concat(e.value.flatMap((lote: Lote) => lote.detalles))));

    const wasChecked = selectedTxsDisponibles.length < detallesSeleccionados.length;

    if (e.type === 'checkbox' || e.type === 'row') {
      if (wasChecked) {
        setSelectedTxsDisponibles(detallesSeleccionados);
      }
      else {
        const deselectedLotes = selectedLotesDisponibles.filter(row => !e.value.includes(row));
        const deselectedTrxIds = deselectedLotes[0].detalles.map((detalle: Transaccion) => detalle.id_transaccion);
        const updatedSelectedTxsDisponibles = selectedTxsDisponibles.filter(tx => !deselectedTrxIds.includes(tx.id_transaccion));
        setSelectedTxsDisponibles(updatedSelectedTxsDisponibles);
      }
    }

    if (e.type === 'all') {
      if (e.value.length > 0) {
        setSelectedTxsDisponibles(detallesSeleccionados);
      }
      else {
        setSelectedTxsDisponibles([]);
      }
    }
  }
  const onSelectedLotesSeleccionados = (e: any) => {    
    setCheckedAllSeleccionadas(!checkedAllSeleccionadas);
    setSelectedLotesSeleccionados(e.value);
    handleSelectedTxsSeleccionadas(e);
  };
  const handleSelectedTxsSeleccionadas = (e: any) => {    
    const detallesSeleccionados = Array.from(new Set(selectedTxsSeleccionadas.concat(e.value.flatMap((lote: Lote) => lote.detalles))));        

    const wasChecked = selectedTxsSeleccionadas.length < detallesSeleccionados.length;

    if (e.type === 'checkbox' || e.type === 'row') {
      if (wasChecked) {      
        setSelectedTxsSeleccionadas(detallesSeleccionados);
      }
      else {
        const deselectedLotes = selectedLotesSeleccionados.filter(row => !e.value.includes(row));
        const deselectedTrxIds = deselectedLotes[0].detalles.map((detalle: Transaccion) => detalle.id_transaccion);
        const updatedSelectedTxsSeleccionadas = selectedTxsSeleccionadas.filter(tx => !deselectedTrxIds.includes(tx.id_transaccion));
        setSelectedTxsSeleccionadas(updatedSelectedTxsSeleccionadas);
      }
    }

    if (e.type === 'all') {
      if (e.value.length > 0) {              
        setSelectedTxsSeleccionadas(detallesSeleccionados);
      }
      else {
        setSelectedTxsSeleccionadas([]);
      }
    }
  }
  const onSelectedTxsDisponibles = (e: any) => {
    setSelectedTxsDisponibles(e.value);
  }
  const onSelectedTxsSeleccionadas = (e: any) => {    
    setSelectedTxsSeleccionadas(e.value);
  }
  function transaccionesConFechaMayor90ds(e:any) {
    const hoy = moment(new Date());
    let filterTxD = e.detalles.filter((detalle: Transaccion) => {
      const fechaPresentacion = moment(detalle.fecha_transaccion);
      const diferencia = moment(fechaPresentacion).diff(hoy, 'days');
      return Math.abs(diferencia) > 90;
    });
    return filterTxD;
  }

  const rowColor = (e : any) => {
    let filterTxD = transaccionesConFechaMayor90ds(e);
    if(filterTxD.length > 0){
      return ""//"rowVerde"
   }else{
    return ""
   }
}

  const actionBodyTemplate = (rowData: any) => {
    const hasPrecioBajo = rowData.detalles.some((detalle: Transaccion) => detalle.precio_bajo === 1);
    const precioBajoIcon = hasPrecioBajo && (
      <i
        className="custom-target-icon pi pi-exclamation-triangle ml-2 p-text-secondary p-overlay-badge"
        data-pr-tooltip={MESSAGE_LOTE_PRECIO_LITRO_BAJO}
        data-pr-position="right"
        data-pr-at="right+5 top"
        data-pr-my="left center-2"
        style={{ fontSize: '2rem', cursor: 'pointer', color: '#cc8925' }}
      ></i>
    );
    let filterTxD = transaccionesConFechaMayor90ds(rowData);
    if (presentacionComercio.descripcion === INICIADA_COMERCIO && filterTxD.length > 0) {
      return (
        <React.Fragment>
          <div style={{ display: 'flex', alignItems: 'center' }} >
            <span>{rowData.cierreLote}</span>
            <div className="flex align-items-center">
              <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon pi pi-exclamation-circle ml-2 p-text-secondary p-overlay-badge"
                data-pr-tooltip={MESSAGE_TRX_FECHA_MAYOR_90_DS}
                data-pr-position="right"
                data-pr-at="right+5 top" data-pr-my="left center-2" style={{ fontSize: '2rem', cursor: 'pointer', color: 'red' }}>
              </i>
              {precioBajoIcon}
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return (<React.Fragment>
        <div style={{ display: 'flex', alignItems: 'center' }} >
          <span>{rowData.cierreLote}</span>
          {precioBajoIcon}
        </div>
      </React.Fragment>)
    }
  }

  const precioLitroBajoCellTemplate = (dataRow: any) => {    
    if (dataRow.precio_bajo == 0) {
      return (<React.Fragment>
        <div style={{ display: 'flex', alignItems: 'center' }} >
          <span>{dataRow.cierreLote}</span>
        </div>
      </React.Fragment>)
    }
    else {
      return (
        <React.Fragment>
          <div style={{ display: 'flex', alignItems: 'center' }} >
            <span>{dataRow.cierreLote}</span>
            <div className="flex align-items-center">
              <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon pi pi-exclamation-triangle ml-2 p-text-secondary p-overlay-badge"
                data-pr-tooltip={MESSAGE_TRX_PRECIO_LITRO_BAJO}
                data-pr-position="right"
                data-pr-at="right+5 top" data-pr-my="left center-2" style={{ fontSize: '2rem', cursor: 'pointer', color: '#cc8925' }}>
              </i>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }

  return (
    <>
      <Toast ref={toast} position="bottom-right" />
      {(presentacionComercio.descripcion === INICIADA_COMERCIO || presentacionComercio.descripcion === RECHAZADA) && <div className="card mb-2">
        
        <DataTable
          ref={dt}
          header={() =>
            renderHeader("Transacciones Disponibles", TRANSACCIONES_DISPONIBLES)
          }
          value={detailsTxDisponibles}
          selection={selectedLotesDisponibles}
          onSelectionChange={(e) => onselectedLotesDisponibles(e)}
          expandedRows={expandedRowsDisponibles}
          onRowToggle={(e) => setExpandedRowsDisponibles(e.data)}          
          responsiveLayout="stack"
          rowExpansionTemplate={(rowData) => rowExpansionTemplate(rowData.detalles, TRANSACCIONES_DISPONIBLES)}
          className="txDataTable p-datatable-customers"
          loading={spinnerTxDisponibles}
          dataKey="nro"          
        >
          <Column expander={allowExpansion} style={{ width: "3em" }} />
          <Column field="nro" header="N°" style={{ width: "4%" }} />

          <Column
            field="cierreLote"
            header="Cierre de lote"
            style={{ width: "14%" }}
            body={actionBodyTemplate} 
            />
                  
          <Column
              field="solucion"
              header="Solución"
              style={{ width: "18%" }}
          />
          <Column
            field="numeroTerminal"
            header="N° de terminal"
            style={{ width: "18%" }}
          />
          <Column
            field="montoSinDescuento"
            header="Total sin descuento"
            body={totalSinDescuentoBodyTemplate}
            style={{ textAlign: "right", width: "18%" }}
          />
          <Column
            field="monto"
            header="Total"
            body={totalBodyTemplate}
            style={{ textAlign: "right", width: "18%" }}
          />
          
          {presentacionEditable && <Column
            className="column-selection"
            selectionMode={
              detailsTxDisponibles.length == 0 ? "single" : "multiple"
            }
            header="Seleccionar"
            headerStyle={{ width: "6%" }}
          />}
        </DataTable>
      </div>
      }
      <div className="card">
        <DataTable
          header={() =>
            renderHeader(
              "Transacciones Seleccionadas",
              TRANSACCIONES_SELECCIONADAS
            )
          }
          value={detailsTxSeleccionadas}
          selection={selectedLotesSeleccionados}
          onSelectionChange={(e) => onSelectedLotesSeleccionados(e)}
          expandedRows={expandedRowsSeleccionadas}
          onRowToggle={(e) => setExpandedRowsSeleccionadas(e.data)}
          //onRowExpand={onRowExpand}
          //onRowCollapse={onRowCollapse}
          responsiveLayout="stack"
          rowExpansionTemplate={(rowData) => rowExpansionTemplate(rowData.detalles, TRANSACCIONES_SELECCIONADAS)}
          className="txDataTable p-datatable-customers"
          loading={spinnerTxSeleccionadas}
          dataKey="nro"
          //rowClassName={(e) => rowColor(e)}
        >
          <Column expander={allowExpansion} style={{ width: "3em" }} />
          <Column field="nro" header="N°" style={{ width: "4%" }} />
          <Column
            field="cierreLote"
            header="Cierre de lote"
            style={{ width: "14%" }}
            body={actionBodyTemplate} 
                  />
                  
         <Column
             field="solucion"
             header="Solución"
             style={{ width: "18%" }}
         />
          <Column
            field="numeroTerminal"
            header="N° de terminal"
            style={{ width: "18%" }}
          />
          <Column
            field="montoSinDescuento"
            header="Total sin descuento"
            body={totalSinDescuentoBodyTemplate}
            style={{ textAlign: "right", width: "18%" }}
          />
          <Column
            field="monto"
            header="Total"
            body={totalBodyTemplate}
            style={{ textAlign: "right", width: "18%" }}
          />

          {(presentacionComercio.descripcion === INICIADA_COMERCIO || presentacionComercio.descripcion === RECHAZADA) && <Column
            className="column-selection"
            selectionMode={
              detailsTxSeleccionadas.length == 0 ? "single" : "multiple"
            }
            header="Seleccionar"
            headerStyle={{ width: "6%" }}
          />}
        </DataTable>
      </div>
    </>
  );
};
export default TransaccionesDetalles;
